
import request from "../utils/request";

export function cmsMoneyApplyadd(data) {
    return request({
        url: "/moneyApply/cmsMoneyApplyadd",
        data: data,
    });
}


export function cmsSelMoneyApply(data) {
    return request({
        url: "/moneyApply/cmsSelMoneyApply",
        data: data,
    });
}

export function cmsUpdateMoneyApply(data) {
    return request({
        url: "/moneyApply/cmsUpdateMoneyApply",
        data: data,
    });
}
